export enum WhatsAppMessageStatus {
  Sent = 0,
  Failed = 1
};
